import { SxProps, Theme } from '@mui/material';

export const DpScrollSubtitleSX: SxProps<Theme> = {
	fontSize: {
		xs: 'var(--font-size-body)',
		sm: 'var(--font-size-body)',
	},
	color: '#2C2C2C',
	marginTop: '10px',
	marginBottom: { xs: '12px' },
	textAlign: { xs: 'center', sm: 'start' },
};
